import React from 'react';
import '../css/StatusIcon.css'; // Assuming your CSS is in styles.css

const StatusIcon = ({ isActive }) => {
    const iconClass = isActive ? 'green' : 'red';
    return <span className={`status-icon ${iconClass}`}></span>;
};

export default StatusIcon;
